/**
 * @file 頂部導覽列元件
 * @description 響應式導覽列，支援行動裝置側滑選單
 */
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { useNavigate } from 'react-router-dom';

import './navbarsStyle.scss';

/** 子路徑介面 */
interface SubPath {
  path: string;
  title: string;
  icon?: string;
}

/** 頂部導覽列 Props */
interface NavbarsProps {
  brand?: string;
  sideNavTitle?: string;
  subPath?: SubPath[];
}

const Navbars: React.FC<NavbarsProps> = ({
  brand = '',
  sideNavTitle = '',
  subPath = []
}) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleClose = (): void => setShow(false);
  const handleShow = (): void => setShow(true);

  return (
    <>
      <Navbar key='md' expand='md'>
        <Container fluid='lg'>
          <Navbar.Brand href='/'>{brand}</Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-md`}
            onClick={handleShow}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-md`}
            aria-labelledby={`offcanvasNavbarLabel-expand-md`}
            placement='end'
            show={show}
            onHide={handleClose}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
                {sideNavTitle}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className='justify-content-end flex-grow-1 pe-3'>
                {subPath.map((_subPath, index) => (
                  <Nav.Link
                    key={`navbars_subPath_${index}`}
                    onClick={() => {
                      navigate(_subPath?.path);
                      handleClose();
                    }}
                    className='navbars_subPath_link'
                  >
                    {_subPath?.title}
                  </Nav.Link>
                ))}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
};

export default Navbars;
